import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import App from "@/App";

// Comprehensive error suppression for ResizeObserver
window.addEventListener('error', (e) => {
  if (e.message.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

window.addEventListener('unhandledrejection', (e) => {
  if (e.reason?.message?.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

// Suppress console errors
const originalError = console.error;
console.error = (...args) => {
  if (typeof args[0] === 'string' && args[0].includes('ResizeObserver loop')) {
    return;
  }
  originalError(...args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <App
              language={
                process.env.REACT_APP_DEFAULT_LANGUAGE === 'arabic'
                  ? 'arabic'
                  : process.env.REACT_APP_DEFAULT_LANGUAGE === 'chinese'
                  ? 'chinese'
                  : 'hebrew'
              }
            />
          }
        />
        <Route path="/arabic" element={<App language="arabic" />} />
        <Route path="/arabic/:customerSlug" element={<App language="arabic" />} />
        <Route path="/hebrew" element={<App language="hebrew" />} />
        <Route path="/hebrew/:customerSlug" element={<App language="hebrew" />} />
        <Route path="/chinese" element={<App language="chinese" />} />
        <Route path="/chinese/:customerSlug" element={<App language="chinese" />} />
        <Route
          path="/:customerSlug"
          element={
            <App
              language={
                process.env.REACT_APP_DEFAULT_LANGUAGE === 'arabic'
                  ? 'arabic'
                  : process.env.REACT_APP_DEFAULT_LANGUAGE === 'chinese'
                  ? 'chinese'
                  : 'hebrew'
              }
            />
          }
        />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
